import React from 'react';
import '../stylesheets/query_table/IncentiveTable.scss';

const IncentiveTable = ({ data = [], columns = [] }) => {
  if (!data || !columns) {
    return <div>No data or columns defined</div>;
  }

  return (
    <div className="table-container">
      <table className="table">
        <thead>
          <tr className="header-row">
            {columns.map((column) => (
              <th key={column.header} className="header-cell">
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex} className="data-row">
              {columns.map((column) => (
                <td key={`${rowIndex}-${column.accessor}`} className="data-cell">
                  {row[column.accessor]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default IncentiveTable;
